import { getIsGretaAIChatRetryableStatus } from '../GretaAIChat.utils'

export function getIsGretaAIChatHistoryRetryable({ isFeedEmpty, status }) {
  return isFeedEmpty && getIsGretaAIChatRetryableStatus(status)
}

export function getIsGretaAIChatAnswerErrorCleared({
  isFeedEmpty,
  isLimitReached,
}) {
  return isLimitReached && !isFeedEmpty
}
